import spacetime from 'spacetime';
import { convertMinutes } from 'utilities/time/conversion';

export const query = `
query paginatedDraftJobRequests(
  $first: Int,
  $after: String,
  $filter: JobRequestDraftFilter
) {
  paginatedDraftJobRequests(
    first: $first,
    after: $after,
    filter: $filter
  ) {
    edges {
      node {
        id
        requestName
        startDate
        payClassification {
          name
        }
        totalDuration
        requestor {
          fullName
        }
        venue {
          name
          address
          city
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
`;

const reducer = payload => ({
  nodes: payload.paginatedDraftJobRequests.edges.filter(edge => edge !== null).map(({ node }) => ({
    ...node,
    requestorName: node?.requestor?.fullName,
    startDate: spacetime(node.startDate).format('{month-short} {date-ordinal}, {year}, {time}'),
    totalDuration: convertMinutes(node.totalDuration),
    classification: node?.payClassification?.name,
  })),
  ...payload.paginatedDraftJobRequests
});

export const paginatedDraftJobRequests = {
  query,
  reducer,
  paginated: true,
};
